import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header } from 'semantic-ui-react';
import server from '../../functions/server';
import userId from '../../functions/userid';
import $ from 'jquery';

export default class EditPhone extends React.Component {
  state = {
    open: false,
    phone: ""
  };

  handleClose = () => {
    this.props.handleState({editphone: false});
  };

  handleUpdate = () => {
    let phone = this.state.phone.trim();
    if (phone.length < 5 || phone.length > 30) {
      this.setState({
        message: "Invalid Phone Number"
      });
      return;
    }
    let data = {
      id: this.props.id,
      owner: userId(),
      type: 'phone',
      value: phone
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/update.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating Mobile Number"
          });
      },
      success: function(data, status) {
        let editphone = true;
        if (data == "1") {
          context.props.updateProps('phone', phone);
          editphone = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editphone

        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.phone) {
      this.setState({
        phone: this.props.phone
      })
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update Phone Number</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Phone Number
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="descriptionText"
              value={this.state.phone}
              type="number"
              onChange={(e) => {this.setState({phone: e.target.value, message:""})}}
              fullWidth
            />
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
